import { useEffect } from 'react';
import DialogBox from '../DialogBox';
import { sessionTimerConfig } from 'config';
import { LOGOUT_NOW, SESSION_ABOUT_TO_EXPIRE, STAY_LOGGED_IN } from 'constants/text/common';
import { useAnalytics } from 'hooks/useAnalytics/useAnalytics';

type ExtendSessionDailog = {
    handleLogout: (isAutoLogout?: boolean) => void;
    handleExtend: () => void;
};

/**
 * Shows extend session dailog and automatically logout if user didn't choose option to extend or logout
 */
export const ExtendSessionDailog = ({ handleExtend, handleLogout }: ExtendSessionDailog) => {
    const { captureMantaCareEvent } = useAnalytics();
    useEffect(() => {
        const sessionTimeConfig = sessionTimerConfig();
        const autoLougoutTimer = setTimeout(() => {
            captureMantaCareEvent({ type: 'session', action: 'expired' });
            handleLogout(true);
        }, sessionTimeConfig.noActionAutoLogoutTimer * 1000);

        return () => {
            clearTimeout(autoLougoutTimer);
        };
    }, []);

    return (
        <DialogBox
            title={SESSION_ABOUT_TO_EXPIRE}
            content={''}
            submitButtonLabel={STAY_LOGGED_IN}
            cancelButtonLabel={LOGOUT_NOW}
            showCancel
            open={true}
            onClose={handleExtend}
            onCancel={handleLogout}
            submit={handleExtend}
        />
    );
};
